'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _omit2 = require('lodash/omit');

var _omit3 = _interopRequireDefault(_omit2);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactMomentProptypes = require('react-moment-proptypes');

var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);

var _DateRangePicker = require('react-dates/lib/components/DateRangePicker');

var _DateRangePicker2 = _interopRequireDefault(_DateRangePicker);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _datePickerConstants = require('./date-picker-constants');

var _datePickerProps = require('./date-picker-props');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./DateRangePickerWrapper.scss');

var DateRangePickerWrapper = (_class = (_temp = _class2 = function (_PureComponent) {
  (0, _inherits3.default)(DateRangePickerWrapper, _PureComponent);

  function DateRangePickerWrapper() {
    var _ref;

    (0, _classCallCheck3.default)(this, DateRangePickerWrapper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = DateRangePickerWrapper.__proto__ || (0, _getPrototypeOf2.default)(DateRangePickerWrapper)).call.apply(_ref, [this].concat(args)));

    var _args$ = args[0],
        startDate = _args$.startDate,
        endDate = _args$.endDate,
        initialStartDate = _args$.initialStartDate,
        initialEndDate = _args$.initialEndDate;

    _this.state = {
      focusedInput: null,
      startDate: startDate ? (0, _moment2.default)(startDate) : initialStartDate,
      endDate: endDate ? (0, _moment2.default)(endDate) : initialEndDate
    };
    return _this;
  }

  (0, _createClass3.default)(DateRangePickerWrapper, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var startDate = nextProps.startDate,
          endDate = nextProps.endDate;

      if (this.props.startDate !== startDate || this.props.endDate !== endDate) {
        this.setState({
          startDate: startDate ? (0, _moment2.default)(startDate) : null,
          endDate: endDate ? (0, _moment2.default)(endDate) : null
        });
      }
    }
  }, {
    key: 'onDatesChange',
    value: function onDatesChange(_ref2) {
      var startDate = _ref2.startDate,
          endDate = _ref2.endDate;
      var focusedInput = this.state.focusedInput;

      this.setState({ startDate: startDate, endDate: endDate });
      this.props.onChange({ startDate: startDate, endDate: endDate, focusedInput: focusedInput });
    }
  }, {
    key: 'onFocusChange',
    value: function onFocusChange(focusedInput) {
      this.setState({ focusedInput: focusedInput });
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          focusedInput = _state.focusedInput,
          startDate = _state.startDate,
          endDate = _state.endDate;
      var className = this.props.className;
      var _context = this.context,
          t = _context.t,
          isMobile = _context.isMobile;

      var props = (0, _omit3.default)(this.props, _datePickerProps.omittedProps);

      return _react2.default.createElement(
        'span',
        { className: (0, _bind2.default)(styles.wrapper, className) },
        _react2.default.createElement(_DateRangePicker2.default, (0, _extends3.default)({
          startDatePlaceholderText: t('Start date'),
          endDatePlaceholderText: t('End date')
        }, props, {
          onDatesChange: this.onDatesChange,
          onFocusChange: this.onFocusChange,
          focusedInput: focusedInput,
          startDate: startDate,
          endDate: endDate,
          withFullScreenPortal: isMobile || props.withFullScreenPortal,
          orientation: isMobile ? _datePickerConstants.VERTICAL_ORIENTATION : props.orientation
        }))
      );
    }
  }]);
  return DateRangePickerWrapper;
}(_react.PureComponent), _class2.propTypes = {
  autoFocusEndDate: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  daySize: _propTypes2.default.number,
  displayFormat: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  enableOutsideDays: _propTypes2.default.bool,
  endDate: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  hideKeyboardShortcutsPanel: _propTypes2.default.bool,
  initialEndDate: _reactMomentProptypes2.default.momentObj,
  initialStartDate: _reactMomentProptypes2.default.momentObj,
  initialVisibleMonth: _propTypes2.default.func,
  isDayBlocked: _propTypes2.default.func,
  isDayHighlighted: _propTypes2.default.func,
  isOutsideRange: _propTypes2.default.func,
  isRTL: _propTypes2.default.bool,
  keepOpenOnDateSelect: _propTypes2.default.bool,
  minimumNights: _propTypes2.default.number,
  monthFormat: _propTypes2.default.string,
  navNext: _propTypes2.default.node,
  navPrev: _propTypes2.default.node,
  numberOfMonths: _propTypes2.default.number,
  onChange: _propTypes2.default.func,
  onNextMonthClick: _propTypes2.default.func,
  onOutsideClick: _propTypes2.default.func,
  onPrevMonthClick: _propTypes2.default.func,
  renderCalendarInfo: _propTypes2.default.func,
  renderDay: _propTypes2.default.func,
  reopenPickerOnClearDates: _propTypes2.default.bool,
  showClearDates: _propTypes2.default.bool,
  showDefaultInputIcon: _propTypes2.default.bool,
  startDate: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  withFullScreenPortal: _propTypes2.default.bool,
  withPortal: _propTypes2.default.bool
}, _class2.contextTypes = {
  isMobile: _propTypes2.default.bool,
  t: _propTypes2.default.func
}, _class2.defaultProps = {
  anchorDirection: _datePickerConstants.ANCHOR_RIGHT,
  autoFocusEndDate: false,
  daySize: _datePickerConstants.DAY_SIZE,
  displayFormat: _datePickerConstants.DISPLAY_FORMAT,
  enableOutsideDays: false,
  hideKeyboardShortcutsPanel: true,
  initialEndDate: null,
  initialStartDate: null,
  initialVisibleMonth: null,
  isDayBlocked: function isDayBlocked() {
    return false;
  },
  isDayHighlighted: function isDayHighlighted() {
    return false;
  },
  isOutsideRange: _noop3.default,
  isRTL: false,
  keepOpenOnDateSelect: false,
  minimumNights: 1,
  monthFormat: 'MMMM YYYY',
  navNext: null,
  navPrev: null,
  numberOfMonths: 2,
  onNextMonthClick: function onNextMonthClick() {},
  onOutsideClick: function onOutsideClick() {},
  onPrevMonthClick: function onPrevMonthClick() {},

  orientation: _datePickerConstants.HORIZONTAL_ORIENTATION,
  renderCalendarInfo: null,
  renderDay: null,
  reopenPickerOnClearDates: false,
  showClearDates: false,
  showDefaultInputIcon: false,
  withFullScreenPortal: false,
  withPortal: false
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onDatesChange', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onDatesChange'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onFocusChange', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onFocusChange'), _class.prototype)), _class);
exports.default = DateRangePickerWrapper;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/DateRangePickerWrapper/DateRangePickerWrapper.js
// module id = 1983
// module chunks = 1